import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/productionPersonalPerformance',
    component: Layout,
    meta: { title: '个人绩效填报' },
    children: [{
      path: '',
      meta: { title: '个人绩效填报', activeMenu: '/productionPersonalPerformance' },
      component: () => import('@/views/smartproduction/performance/ProductionPersonalPerformance.vue')
    }]
  },
  {
    path: '/productionPerformance',
    meta: { title: '生产绩效' },
    component: Layout,
    redirect: '/productionPerformance',
    children: [
      {
        path: '',
        meta: { title: '生产绩效', activeMenu: '/productionPerformance' },
        component: () => import('@/views/smartproduction/performance/ProductionPerformance.vue')
      },
      {
        path: 'detail',
        meta: { title: '生产绩效详情', activeMenu: '/productionPerformance' },
        component: () => import('@/views/smartproduction/performance/ProductionPerformanceDetail.vue')
      }
    ]
  },
  {
    path: '/warehouse',
    meta: { title: '仓库管理' },
    component: Layout,
    redirect: '/warehouse/list',
    children: [
      {
        path: 'list',
        meta: { title: '价格管理', activeMenu: '/warehouse' },
        component: () => import('@/views/smartproduction/warehouse/Warehouse.vue')
      },
      {
        path: 'detail',
        meta: { title: '仓库详情', activeMenu: '/warehouse' },
        component: () => import('@/views/smartproduction/warehouse/WarehouseDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑仓库', activeMenu: '/warehouse' },
        component: () => import('@/views/smartproduction/warehouse/WarehouseAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增仓库', activeMenu: '/warehouse' },
        component: () => import('@/views/smartproduction/warehouse/WarehouseAdd.vue')
      }

    ]
  },
  {
    path: '/productmanage',
    meta: { title: '产品管理' },
    component: Layout,
    redirect: '/productmanage/list',
    children: [
      {
        path: 'list',
        meta: { title: '产品列表', activeMenu: '/productmanage' },
        component: () => import('@/views/smartproduction/productmanage/ProductManage.vue')
      },
      {
        path: 'detail',
        meta: { title: '产品详情', activeMenu: '/productmanage' },
        component: () => import('@/views/smartproduction/productmanage/ProductManageDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑产品', activeMenu: '/productmanage' },
        component: () => import('@/views/smartproduction/productmanage/ProductManageAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增产品', activeMenu: '/productmanage' },
        component: () => import('@/views/smartproduction/productmanage/ProductManageAdd.vue')
      }
    ]
  },
  {
    path: '/productrecord',
    meta: { title: '生产记录' },
    component: Layout,
    redirect: '/productrecord/list',
    children: [
      {
        path: 'list',
        meta: { title: '生产记录', activeMenu: '/productrecord' },
        component: () => import('@/views/smartproduction/productrecord/ProductRecord.vue')
      },
      {
        path: 'detail',
        meta: { title: '生产记录详情', activeMenu: '/productrecord' },
        component: () => import('@/views/smartproduction/productrecord/ProductRecordDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增生产记录', activeMenu: '/productrecord' },
        component: () => import('@/views/smartproduction/productrecord/ProductRecordAdd.vue')
      }
    ]
  },
  {
    path: '/inventorytotal',
    meta: { title: '产品库存' },
    component: Layout,
    redirect: '/inventorytotal/list',
    children: [
      {
        path: 'list',
        meta: { title: '产品库存', activeMenu: '/inventorytotal' },
        component: () => import('@/views/smartproduction/inventorymanage/InventoryTotal.vue')
      },
      {
        path: 'detail',
        meta: { title: '产品库存详情', activeMenu: '/inventorymanage' },
        component: () => import('@/views/smartproduction/inventorymanage/InventoryManageDetail.vue')
      }
    ]
  },
  {
    path: '/inventorymanage',
    meta: { title: '产品库存' },
    component: Layout,
    redirect: '/inventorymanage/list',
    children: [
      {
        path: 'list',
        meta: { title: '产品库存', activeMenu: '/inventorymanage' },
        component: () => import('@/views/smartproduction/inventorymanage/InventoryManage.vue')
      },
      {
        path: 'detail',
        meta: { title: '产品库存详情', activeMenu: '/inventorymanage' },
        component: () => import('@/views/smartproduction/inventorymanage/InventoryManageDetail.vue')
      }
    ]
  },
  {
    path: '/inventoryflow',
    meta: { title: '库存流水' },
    component: Layout,
    redirect: '/inventoryflow/list',
    children: [
      {
        path: 'list',
        meta: { title: '库存流水', activeMenu: '/inventoryflow' },
        component: () => import('@/views/smartproduction/inventoryflow/InventoryFlow.vue')
      },
      {
        path: 'detail',
        meta: { title: '库存流水详情', activeMenu: '/inventoryflow' },
        component: () => import('@/views/smartproduction/inventoryflow/InventoryFlowDetail.vue')
      }
    ]
  },
  {
    path: '/finishedgoodsinbound',
    meta: { title: '成品入库' },
    component: Layout,
    redirect: '/finishedgoodsinbound/list',
    children: [
      {
        path: 'list',
        meta: { title: '成品入库', activeMenu: '/finishedgoodsinbound' },
        component: () => import('@/views/smartproduction/finishedgoodsinbound/FinishedGoodsInbound.vue')
      },
      {
        path: 'detail',
        meta: { title: '成品入库详情', activeMenu: '/finishedgoodsinbound' },
        component: () => import('@/views/smartproduction/finishedgoodsinbound/FinishedGoodsInboundDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑成品入库', activeMenu: '/finishedgoodsinbound' },
        component: () => import('@/views/smartproduction/finishedgoodsinbound/FinishedGoodsInboundAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增成品入库', activeMenu: '/finishedgoodsinbound' },
        component: () => import('@/views/smartproduction/finishedgoodsinbound/FinishedGoodsInboundAdd.vue')
      }
    ]
  },
  {
    path: '/finishedgoodsoutbound',
    meta: { title: '成品出库' },
    component: Layout,
    redirect: '/finishedgoodsoutbound/list',
    children: [
      {
        path: 'list',
        meta: { title: '成品出库', activeMenu: '/finishedgoodsoutbound' },
        component: () => import('@/views/smartproduction/finishedgoodsoutbound/FinishedGoodsOutbound.vue')
      },
      {
        path: 'detail',
        meta: { title: '成品出库详情', activeMenu: '/finishedgoodsoutbound' },
        component: () => import('@/views/smartproduction/finishedgoodsoutbound/FinishedGoodsOutboundDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑成品出库', activeMenu: '/finishedgoodsoutbound' },
        component: () => import('@/views/smartproduction/finishedgoodsoutbound/FinishedGoodsOutboundAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增成品出库', activeMenu: '/finishedgoodsoutbound' },
        component: () => import('@/views/smartproduction/finishedgoodsoutbound/FinishedGoodsOutboundAdd.vue')
      }
    ]
  },
  {
    path: '/feedingrecord',
    meta: { title: '投料记录' },
    component: Layout,
    redirect: '/feedingrecord/list',
    children: [
      {
        path: 'list',
        meta: { title: '投料记录', activeMenu: '/feedingrecord' },
        component: () => import('@/views/smartproduction/feedingrecord/FeedingRecord.vue')
      },
      {
        path: 'detail',
        meta: { title: '投料记录详情', activeMenu: '/feedingrecord' },
        component: () => import('@/views/smartproduction/feedingrecord/FeedingRecordDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑投料记录', activeMenu: '/feedingrecord' },
        component: () => import('@/views/smartproduction/feedingrecord/FeedingRecordAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增投料记录', activeMenu: '/feedingrecord' },
        component: () => import('@/views/smartproduction/feedingrecord/FeedingRecordAdd.vue')
      }
    ]
  },
  {
    path: '/materialoutbound',
    meta: { title: '原辅料出库' },
    component: Layout,
    redirect: '/materialoutbound/list',
    children: [
      {
        path: 'list',
        meta: { title: '原辅料出库', activeMenu: '/materialoutbound' },
        component: () => import('@/views/smartproduction/materialoutbound/MaterialOutbound.vue')
      },
      {
        path: 'detail',
        meta: { title: '原辅料出库详情', activeMenu: '/materialoutbound' },
        component: () => import('@/views/smartproduction/materialoutbound/MaterialOutboundDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑原辅料出库', activeMenu: '/materialoutbound' },
        component: () => import('@/views/smartproduction/materialoutbound/MaterialOutboundAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增原辅料出库', activeMenu: '/materialoutbound' },
        component: () => import('@/views/smartproduction/materialoutbound/MaterialOutboundAdd.vue')
      }
    ]
  }

]
